const quotesData = [
  {
    quote:
      `"Every day may not be good but there is something good in every day!"`,
  },
  {
    quote:
      `"When things get tough remember: better days are coming. They are called Saturday and Sunday."`,
  },
  { quote: `"Choose to be optimistic. It feels better."` },
  {
    quote:
      `"Just in case no one told you today: Good morning! You are doing great. I believe in you. Nice butt."`,
  },
  {
    quote:
      `"Breathe. Don't let a bad day make you feel like you have a bad life."`,
  },
  {
    quote: `"A good laugh and a long sleep are the two best cures for anything."`,
  },
  { quote: `"Do something today that you future self will thank you for."` },
  { quote: `"Start where you are. Use what you have. Do what you can."` },
  {
    quote:
      `"Don’t wait for your feelings to change to take the action. Take the action and your feelings will change."`,
  },
  {
    quote:
      `"You measure the size of the accomplishment by the obstacles you had to overcome to reach your goals."`,
  },
  {
    quote: `"School of Code is your opportunity to challenge yourself."`
  },
  {
    quote: `"It is up to you to begin your cycle on the hero’s journey - push past the resistance!"`
  },
  {
    quote: `"Set backs are part of the process. If you’re not facing them, you’re in your comfort zone!"`
  },
  {
    quote: `"Aikido Masters say: It’s not about never being off balance, it’s about the speed at which you recover."`
  },
  {
    quote: `"Try to not be too positional with your opinions, being more generative helps keep an open mind"`
  },
  {
    quote: `"Remember the School of Code is an accelerated learning environment, don’t forget to take breaks!"`
  },
  {
    quote: `"If you don’t agree with the team decision, remember you have a choice between your ego and the team dynamic."` 
  },
  {
    quote: `"School of Code is about team learning and growing together. If we’re wrong, it’s as a team and we can all work together to put it right."`
  },
  {
    quote: `"The team expects you to speak up if something’s wrong, it’s how we do things."`
  },
];

export default quotesData;
